import * as React from "react";
import { useTranslation } from "../../i18n/custom.i18n";
import i18next from "../../i18n/i18n.config";
import ReactMarkdown from 'react-markdown'
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import remarkBreaks from "remark-breaks";

import * as DetailsUtils from "./details-utils";
import "./addin.css";
import { LazyLoadImageCDN } from "../Card/CDNImage";

let currencyData = {};
let postFetchCurrencyRender = null;
window.addEventListener('load', async() => {
    currencyData = await window.fetchCurrency();
    if (postFetchCurrencyRender != null)
        postFetchCurrencyRender(true);
});

export const Addin = (props: any) => {
    //console.log(props)
    //console.log("type", DetailsUtils.type);
    //console.log("data", props.item_data);
    const { t, i18n } = useTranslation();
    const [fetchedCurrency, setFetchedCurrency] = React.useState(false);

    const created_date = (props.item_data.hasOwnProperty("DC") ? new Date(props.item_data["DC"]) : "");
    const modified_date = (props.item_data.hasOwnProperty("DM") ? new Date(props.item_data["DM"]) : "");
    if (props.item_data.hasOwnProperty("LNK")){
        if (props.item_data["LNK"].includes("//")){
            window.location.href = props.item_data["LNK"];
        } else {
            window.location.href = window.location.href.substring(0, window.location.href.lastIndexOf("/")) + "/" + props.item_data["LNK"];
        }
        return;
    }

    const category_link = window.Settings.LOCAL_BUILD
        ? "http://localhost:3004#filter?category=" + props.item_data["C"]
        : "https://robodk.com/addins#filter?category=" + props.item_data["C"];
    const publisher_link = window.Settings.LOCAL_BUILD
        ? "http://localhost:3004#filter?publisher=" + props.item_data["P"].replace(/\s/g, "-").toLowerCase()
        : "https://robodk.com/addins#filter?publisher=" + props.item_data["P"].replace(/\s/g, "-").toLowerCase();
    const id_link = window.Settings.LOCAL_BUILD
        ? "http://localhost:3004#filter?name=" + props.item_data["ID"]
        : "https://robodk.com/addins#filter?name=" + props.item_data["ID"];
    

    const has_desc = props.item_data.hasOwnProperty("D");
    const contact_num = props.item_data.hasOwnProperty("CF") ? props.item_data["CF"] : 0;
    const [desc, setDesc] = React.useState("");

    if (props['item_data'].hasOwnProperty("PX")) {
        if (!props['item_data']['PX'].hasOwnProperty(currencyData["Currency"])) {
            currencyData["Currency"] = "eur";
            currencyData["Symbol"] = "€";
        }
    }

    React.useEffect(() => {
        const load_md = async () => {
            const link = window.Paths.ROBODK_CDN + window.Paths.FOLDER_ADDINS_IMG_CDN + props.item_data["BN"] + "/" + props.item_data["MD"];

            // const md = await fetch("Sources/Addins/files/" + props.item_data["MD"]).then(
            if(props.item_data["MD"] != undefined && props.item_data["MD"] != "") {
                const md = await fetch(link).then(
                    (res) => {
                        // If 404, set to empty
                        if (!res.ok) return "#"; 
                        return res.text();
                    }
                ).then(
                    (text) => {
                        // Image paths are resolved by the img renderer below, which handles every prefix
                        setDesc(text);
                    }
                ).catch(
                    (err) => {
                        setDesc('#')
                        console.log("err", err)
                    }
                );
            } else {
                setDesc('# ' + props.item_data["N"] +"\n"+ props.item_data["D"])
            };

            postFetchCurrencyRender = setFetchedCurrency;
        };

        load_md();

        return () => {}
    }, [])

    const open_buy_link = () => {
        window.open(window.Paths.ROBODK_BUY + "?addin_name=" + encodeURI(props.item_data["N"]) + "&addin_code=" + props.item_data["ID"] + "&addin_price=" + props['item_data']['PX'][currencyData['Currency']], '_blank')
    }

    const open_contact_form = () => {
        const form = document.getElementById("form") as HTMLFormElement;
        
        const form_ta = document.getElementById("form-text-area") as HTMLTextAreaElement;
        form_ta.value = "Hi, I would like to request the " + props.item_data["N"] + " Add-in. How do we proceed?"
        
        form.submit();
    };

    const open_publisher_home = () => {
        window.open(props.item_data["link"]["homepage"], '_blank'); 
    };

    return (
        <>
            <div id="main-container" className="container-fluid" style={{ wordBreak: "break-word" }}>
                <div className={"row"} style={{ backgroundColor: "#eff1f3" }}>
                    <div className={"col col-lg-6 offset-lg-3 col-12"}>
                        {contact_num == 1 && (
                            <form
                                id="form" 
                                target="_blank"

                                method="post"
                                action="https://robodk.com/contact?request-addin"
                            >
                                <input 
                                    id="form-text-area"
                                    className="form-control"
                                    type="textarea"
                                    name="message"
                                    defaultValue={"I would like to request the " + props.item_data["N"] + " Add-in. How should we proceed?"}
                                    style={{display: "none"}}
                                />
                            </form>
                        )}

                        <div id="header-horizontal-container">
                            <LazyLoadImageCDN 
                                cdnPath={DetailsUtils.img_cdn}
                                localPath={DetailsUtils.img}
                                alt={props.item_data["N"]}
                                libAssetsPath={window.Paths.ADDIN_LIB_ASSETS}
                                id="addin-logo"
                            />

                            <div id="header-vertical-container">
                                <div 
                                    // className="addin-button-group"
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        // flexWrap: 'wrap',
                                        // gap: '.5rem'
                                    }}
                                >
                                    <h1>{props.item_data["N"]} Add-in</h1>
                                    {props['item_data'].hasOwnProperty("PX") && (
                                        <p>{window.format_currency(currencyData['Currency'], props['item_data']['PX'][currencyData['Currency']])}</p>
                                    )}
                                </div>

                                <a 
                                    href={props.item_data["link"]["homepage"]}
                                    target="_blank"
                                >
                                    {props.item_data["P"]}
                                </a>

                                {has_desc && (
                                    <div id={"header-desc"}>
                                        {props.item_data["D"]}
                                    </div>
                                )}

                                <div 
                                    className="addin-button-group"
                                    // style={{
                                    //     display: "flex",
                                    //     flexDirection: "row",
                                    //     paddingRight: ".5rem",
                                    // }}
                                >
                                    {contact_num == 0 && (
                                        <button 
                                            id={"download-btn"}
                                            onClick={(e) => DetailsUtils.download_item(props.item_data)}
                                        >
                                            {t('library-overlays.cardDownloadBtn')}
                                        </button>
                                    )}
                                    {window.Settings.enable_buy && props.item_data.hasOwnProperty("PX") && props['item_data']['PX'].hasOwnProperty(currencyData["Currency"]) && (
                                        <button
                                            id="contact-btn"
                                            onClick={open_buy_link}
                                            style={{backgroundColor: "#008a43"}}
                                        >
                                            {t('library-overlays.cardBuyBtn')}
                                        </button>
                                    )}
                                    {contact_num == 1 && (
                                        <button
                                            id="contact-btn"
                                            onClick={open_contact_form}
                                        >
                                            {t('library-overlays.cardContactBtn')}
                                        </button>
                                    )}
                                    {props.item_data["P"] != "RoboDK" && props.item_data["link"] != undefined && props.item_data["link"]["homepage"] != "" && (
                                        <button
                                            id="contact-publisher-btn"
                                            onClick={open_publisher_home}
                                        >
                                            {t('library-overlays.cardContact').replace(/\{name\}/g, props.item_data["P"])}
                                        </button>
                                    )}
                                    {contact_num == 0 && (
                                        <button
                                            id={"install-btn"}
                                            onClick={(e) => window.get_lib(true, props.item_data["F"], "addin")}
                                        >
                                            {t('library-overlays.cardInstallBtn')}
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div 
                        className={"col col-lg-4 offset-lg-3 col-12"}
                        style={{ marginBottom: "3rem", marginTop: "1.5rem" }}
                    >
                        <ReactMarkdown 
                            children={desc}
                            remarkPlugins={[remarkGfm, remarkBreaks]}
                            rehypePlugins={[rehypeRaw] as any}
                            components={{
                            img({...nodeProps}) {
                                    // Resolve relative links against the add-in folder, with or without a leading "./"
                                    const src = nodeProps.src || "";
                                    const is_absolute = /^(?:[a-z][a-z0-9+.-]*:)?\/\//i.test(src) || src.startsWith("data:");
                                    const rel = src.replace(/^[./]+/, "");
                                    const base = props.item_data["BN"] + "/";
                                    return <LazyLoadImageCDN
                                        cdnPath={is_absolute ? src : window.Paths.ROBODK_CDN + window.Paths.FOLDER_ADDINS_IMG_CDN + base + rel}
                                        localPath={is_absolute ? src : window.Paths.FOLDER_ADDINS_IMG + base + rel}
                                        alt={nodeProps.id}
                                        max_width={"100%"}
                                        height={"auto"}
                                    />
                                }
                            } }
                        />
                    </div>

                    <div className={"col col-lg-3 col-12"} style={{ marginTop: "1.5rem" }}>
                        <div className={"addin-info-block left-border"}>
                            <h5>{t("details.addintype")}</h5>
                            <div className={"addin-info-btn-container"}>
                                <button 
                                    className="addin-info-btn"
                                    onClick={(e) => {
                                        window.open(category_link, "_blank");
                                    }}
                                >
                                    {props.item_data["C"]}
                                </button>
                            </div>
                        </div>

                        <div className={"addin-links-block left-border"}>
                            <h5>{t("details.links")}</h5>
                            <div className={"addin-link"}>
                                <a
                                        href={props.item_data["link"].hasOwnProperty("docs") ? props.item_data["link"]["docs"] : ("/doc/" + window.Languages.language + "/Add-ins.html") }
                                        target="_blank"
                                    >{t("details.doc")}</a>
                                {props.item_data["link"].hasOwnProperty("repos") && (
                                    <a
                                        href={props.item_data["link"]["repos"]}
                                        target="_blank"
                                    >{t("details.source")}</a>
                                )}
                                <a
                                        href="/addins"
                                        target="_blank"
                                    >{t("details.alladdins")}</a>
                                {props.item_data["link"].hasOwnProperty("homepage") && (
                                    <a
                                        href={props.item_data["link"]["homepage"]}
                                        target="_blank"
                                    >{t("details.pubhome")}</a>
                                )}
                            </div>
                        </div>

                        <div className={"addin-more-info-block left-border"}>
                            <h5>{t("details.moreinfo")}</h5>
                            <table>
                                <tbody className={"addin-more-info-table"}>
                                    {props.item_data.hasOwnProperty("V") && (
                                        <tr>
                                            <td>{t("details.version")}</td>
                                            <td>{props.item_data["V"]}</td>
                                        </tr>
                                    )}
                                    {created_date != "" && (
                                        <tr>
                                            <td>{t("details.created")}</td>
                                            <td>{created_date.toDateString().split(' ').slice(1).join(' ')}</td>
                                        </tr>
                                    )}
                                    {modified_date != "" && (
                                        <tr>
                                            <td>{t("details.modified")}</td>
                                            <td>{modified_date.toDateString().split(' ').slice(1).join(' ')}</td>
                                        </tr>
                                    )}
                                    {props.item_data.hasOwnProperty("P") && (
                                        <tr>
                                            <td>{t("details.publisher")}</td>
                                            <td>
                                                <a href={publisher_link} target="_blank">
                                                    {props.item_data["P"]}
                                                </a>
                                            </td>
                                        </tr>
                                    )}
                                    {
                                    /*
                                    props.item_data.hasOwnProperty("ID") && (
                                        <tr>
                                            <td>ID</td>
                                            <td>
                                                <a href={id_link} target="_blank">
                                                    {props.item_data["ID"]}
                                                </a>
                                            </td>
                                        </tr>
                                    )
                                    */
                                    }
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>

            </div>
        </>
    )
}